import { ImageElement } from './types';

/**
 * Try to load an image if it's not loaded yet.
 * @param images
 * @param index
 */
export const tryToLoadImage = (images: ImageElement[], index: number) => {
  const image = images[index];
  if (image && !image.src) {
    // Set `src` will trigger the image loading.
    image.src = image.imgSrc;
  }
};

/**
 * Limit a value within a range.
 * @param value
 * @param min
 * @param max
 */
export const limitWithinRange = (value: number, min: number, max: number) => {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
};

/**
 * Check if two float numbers are equal.
 * @param a
 * @param b
 */
export const floatEqual = (a: number, b: number) => {
  return Math.abs(a - b) < Number.EPSILON;
};
